import React from "react";
import useActiveTenants from "../hooks/useActiveTenants";
import "../assets/css/DigixLeads.css";

/** Staff pages show tenant-owned data only after a tenant is chosen here. */
export default function TenantSelectBar({ value, onChange, hint = "Select a tenant to load its data.", label = "Tenant / Client *", inline = false, style }) {
  const tenants = useActiveTenants();
  const options = (
    <>
      <option value="">Select a tenant…</option>
      {tenants.map((t) => (
        <option key={t.id} value={t.id}>
          {t.name}
        </option>
      ))}
    </>
  );

  if (inline) {
    return (
      <select
        className={`re-tenant-select--inline${!value ? " is-empty" : ""}`}
        value={value || ""}
        onChange={(e) => onChange?.(e.target.value)}
        aria-label={label}
        title={!value ? hint : label}
        style={style}
      >
        {options}
      </select>
    );
  }

  return (
    <div className="re-tenant-select">
      <label>
        {label}
        <select
          className="search-filter-input search-filter-select"
          value={value || ""}
          onChange={(e) => onChange?.(e.target.value)}
        >
          {options}
        </select>
      </label>
      {!value ? <span className="re-tenant-select__hint">{hint}</span> : null}
    </div>
  );
}
